export default __webpack_public_path__ + "static/media/archive-icon.6c3b1848.svg";